import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

interface IContainerProps {
  isXsDown: boolean;
}

export const Container = styled('li')<IContainerProps>`
  width: 100%;
  max-width: 1280px;
  display: flex;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.14);
  border-radius: 5px;

  & + li {
    margin-top: 1rem;
  }

  a:hover {
    h3 {
      text-decoration: underline;
    }
  }

  img {
    border-radius: 5px;
  }

  p {
    margin: 10px 0;
    color: ${(props) => props.theme.palette.darkNeutral.main};
    font-size: ${(props) => props.theme.typography.h6.fontSize};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    &:nth-child(1) {
      margin: 0 0 10px 0;
    }
  }

  h3 {
    font-size: ${(props) => props.theme.typography.h3.fontSize};
    color: ${(props) => props.theme.palette.primary.main};
    font-weight: 700;
    margin: 0;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  span {
    font-weight: 700;
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

export const DivContent = styled(Box)`
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const ButtonContentFavorite = styled('button')`
  background-color: transparent;
  outline: 0;
  border: 0;
  cursor: pointer;
`;

interface IDivContentCardFooterProps {
  isXsDown?: boolean;
}

export const DivContentCardFooter = styled('div')<IDivContentCardFooterProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  span {
    color: ${(props) => props.theme.palette.primary.main};
    font-size: ${(props) => props.theme.typography.body1.fontSize};
  }

  .time-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.8rem;

    span {
      color: ${(props) => props.theme.palette.primary.main};
      font-size: ${(props) => props.theme.typography.body1.fontSize};
    }

    .duration {
      font-weight: 700;
    }
  }

  a {
    background-color: ${(props) => props.theme.palette.secondary.main};
    color: ${(props) => props.theme.palette.primary.main};
    font-size: ${(props) => props.theme.typography.body2.fontSize};
    padding: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    min-width: 130px;
    font-weight: 600;
    border-radius: 20px;

    &:hover {
      filter: brightness(0.9);
      text-decoration: none;
    }

    svg {
      margin-left: 10px;
    }
  }
`;

export const TermTextContainer = styled('div')`
  a,
  p,
  small {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const TermContentText = styled('p')`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    display: none;
  }
`;
